import { DASHBOARD_MEMBERS_LINK } from '@components/Router/constants'
import type { ID } from '@octopus-do/octopus-project-core'
import { UserFriends } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { SidebarLink } from '../SidebarLink'

interface Props {
  id: ID
}

export const MembersLink: React.FC<Props> = ({ id }) => (
  <SidebarLink
    to={`${DASHBOARD_MEMBERS_LINK}/${id}`}
    label="Members"
    icon={UserFriends}
  />
)
